import { trackInternalEvent } from '@rio/tracking'
import { ready } from 'shared/ready'

const HEIGHT_OFFSET_TEMPLATE_CARD = 300

class StickyTemplatesSelection {
  constructor() {
    this.$templates = document.getElementsByClassName('templates-grid__cell')
    const stickSkipTemplatesContainerElements = document.getElementsByClassName(
      'sticky_skip_templates_container',
    )

    this.$lastTemplate = this.$templates && this.$templates[this.$templates.length - 1]
    this.$stickSkipTemplatesElement =
      stickSkipTemplatesContainerElements && stickSkipTemplatesContainerElements[0]

    if (!this.$lastTemplate) return
    // template category element
    const lastTemplateTopPosition = this.$lastTemplate.offsetTop

    document.addEventListener('scroll', _ => {
      let lastKnownScrollPosition = window.scrollY
      if (lastKnownScrollPosition >= lastTemplateTopPosition + HEIGHT_OFFSET_TEMPLATE_CARD) {
        this.$stickSkipTemplatesElement.classList.add('hidden')
      } else if (lastKnownScrollPosition < lastTemplateTopPosition + HEIGHT_OFFSET_TEMPLATE_CARD) {
        this.$stickSkipTemplatesElement.classList.remove('hidden')
      }
    })

    this.$stickyUseTemplate = document.getElementById('sticky_use_template')
    this.$stickyUseTemplate &&
      this.$stickyUseTemplate.addEventListener('click', this.chooseVisbleTemplate.bind(this))
  }

  chooseVisbleTemplate(event) {
    event.preventDefault()

    for (let i = 0; i < this.$templates.length; i++) {
      const rect = this.$templates[i].getBoundingClientRect()
      const visible = rect.top + HEIGHT_OFFSET_TEMPLATE_CARD > 0

      let templateName
      if (visible) {
        templateName = this.$templates[i].getAttribute('data-name')

        trackInternalEvent('click_use_this_template_selection', {
          block: 'sticky',
          label: window.location.pathname,
          template: templateName,
        })

        window.location.href = `/app/create-resume/templates?template=${templateName}`
        return
      }
    }
  }
}

ready(function () {
  new StickyTemplatesSelection()
})
